<template>

    <div id="agility_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="container">

            <div class="agility_scores_container">

                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.R_1" :score="currentEval.saven_test.respect_scores.candidate.R_1" dimId="R_1" :animDelay="50" />
                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.E_2" :score="currentEval.saven_test.respect_scores.candidate.E_2" dimId="E_2" :animDelay="150" />
                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.S_3" :score="currentEval.saven_test.respect_scores.candidate.S_3" dimId="S_3" :animDelay="200" />
                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.P_4" :score="currentEval.saven_test.respect_scores.candidate.P_4" dimId="P_4" :animDelay="250" />
                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.E_5" :score="currentEval.saven_test.respect_scores.candidate.E_5" dimId="E_5" :animDelay="300" />
                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.C_6" :score="currentEval.saven_test.respect_scores.candidate.C_6" dimId="C_6" :animDelay="350" />
                <RespectScore :refScore="currentEval.saven_test.respect_scores.sight_ref.T_7" :score="currentEval.saven_test.respect_scores.candidate.T_7" dimId="T_7" :animDelay="400" />


            </div>

        </div>
    </div>

</template>

<script>
import RespectScore from '../scores/respectScore'

export default {
    name: 'RespectTab',
    components: {
        RespectScore
    },
    beforeCreate() {

    },
    data(){
        return {
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.agility_scores_container{
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .agility_score_item:last-child{
        border-right: 1px solid $grey-lighter;
    }
}
</style>